import { render } from "./CostManagement.vue?vue&type=template&id=773f96e8&scoped=true"
import script from "./CostManagement.vue?vue&type=script&lang=js"
export * from "./CostManagement.vue?vue&type=script&lang=js"

import "./CostManagement.vue?vue&type=style&index=0&id=773f96e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773f96e8"]])

export default __exports__